<template>
  <div class="Form-field Form-autoComplete">
    <label
      v-if="label"
      :for="id"
      class="Form-label"
    >
      {{ label }}
      <span
        v-if="required"
        class="Form-required"
      >
        *
      </span>
    </label>
    <div
      :class="['Form-inputBox', {'Form--iconTick': !error.invalid && error.dirty || !error.invalid && activeValidation}]"
    >
      <v-select
        :id="id"
        :model-value="modelValue"
        :clearable="clearable"
        :options="items"
        :disabled="disabled"
        :searchable="searchable"
        :multiple="multiple"
        :taggable="taggable"
        :placeholder="placeholder"
        :class="[{'form-valid': !error.invalid && error.dirty || !error.invalid && activeValidation, 'multiple': multiple}]"
        :label="optionKey"
        :close-on-select="closeOnSelect"
        @search:blur="isBlurred = true"
        @update:modelValue="onChange"
      >
        <template
          slot="option"
          slot-scope="option"
        >
          <span
            v-if="option.image"
            class="AutoComplete-image"
          >
            <img
              :src="option.image"
              :alt="option.name"
              style="width: 30px;height: 30px;"
            >
          </span>
          {{ option.name }}
        </template>
      </v-select>
    </div>
    <error-messages
      :errors="error.errors"
      :is-blurred="isBlurred"
      :manual-validate="manualValidate"
    />
    <hint-message
      :hint="hint"
    />
  </div>
</template>

<script>
/* eslint no-underscore-dangle: 0 */
import vSelect from 'vue-select';
import formInputMixin from '@/mixins/form-input-mixin';

export default {
  name: 'RmpAutoComplete',

  components: {
    'v-select': vSelect,
  },

  mixins: [formInputMixin],

  props: {
    // ID use for binding the for attribute of associated label
    id: {
      type: String,
      default() {
        return `select-id-${Math.floor(Math.random() * 1000) * 5}`;
      },
    },
    manualValidate: {
      type: Boolean,
      default: false,
    },
    optionKey: {
      type: String,
      default: 'name',
    },
    // When the store data will be held, e.g. v-model in a normal input
    modelValue: {
      type: [Array, Object, String, Number],
      default: null,
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    // v-select prop
    multiple: {
      type: Boolean,
      default: false,
    },

    // v-select prop
    taggable: {
      type: Boolean,
      default: false,
    },
    // v-select prop
    disabled: {
      type: Boolean,
      default: false,
    },

    // v-select prop
    placeholder: {
      type: String,
      default: 'Select an option',
    },

    clearable: {
      type: Boolean,
      default: false,
    },

    // TODO: remove
    // v-select doesnt play nicely with this approach
    // https://trello.com/c/Hk0NmkaQ/15-optionally-return-a-specific-key-from-selected-objects
    // returnOnlyValue: {
    //   type: Boolean,
    //   default: false,
    // },

    activeValidation: {
      type: Boolean,
      default: false,
    },

    // define whether to show star in label
    required: {
      type: Boolean,
      default: false,
    },

    // Error messages to display
    error: {
      default() {
        return {};
      },
      type: Object,
    },

    // Hint to show below field
    hint: {
      default: null,
      type: Object,
    },

    // Form label
    label: {
      type: String,
      default: null,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    // v-select prop
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  emits: ['update:modelValue', 'rmp:change'],

  data() {
    return {
      isBlurred: false,
    };
  },
  methods: {
    onChange(event) {
      // Trigger blur hear so we account of when users remove tags from multiselect fields.
      this.$emit('update:modelValue', event);
      this.$emit('rmp:change', event);
    },
  },
};
</script>

<style lang="scss">
  .v-select.vs--searchable,
  .v-select.vs--unsearchable {
    .vs__dropdown-toggle {
      background: #fff;
      height: auto;
      border-radius: radius();
      padding: 0;
    }
    .open-indicator{
      margin-right: 8px;
    }
    &.vs--open {
      .vs__dropdown-toggle {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }

  .v-select.vs--searchable .vs__dropdown-toggle input {
    width: 0;
  }

  .vs__dropdown-toggle {
    height: 40px;
  }

  .v-select input[type=search]{
    margin:0 !important;
    height: auto;
  }

  .v-select.vs--open .vs__dropdown-menu{
    z-index: 2;
  }

  .dropdown li {
    margin-bottom: 0;
  }

  .dropdown li a{
   padding: 10px;
  }
  .v-select.vs--open .vs__dropdown-menu{
    border-top: 1px solid;
    margin-top: -1px;
  }

  /*.v-select.open .dropdown-toggle{ border-bottom: transparent}*/
</style>
